import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import React from "react";
import {MobileMenuItemContainerBox} from "../boxes/mobile-menu-item-container.box";
import {MobileMenuItemLinkBox} from "../boxes/mobile-menu-item-link.box";
import { GenericSideMenuIconBox } from "../../side-menu-rework/side-menu-link/boxes/link/generic-side-menu-icon.box";
import {
    StateSelectorButtonComponent
} from "../../header/top-header-right/state-selector-button/state-selector-button.component";

export class MobileStateSelectorMenuItemComponent extends OrbitComponent {

    private _openStateSelectorPopup = () => {
        this.services.stateOfResidenceIdentifier.displayStateSelectorPopup({
            forceDisplay: true
        });
    }

    render() {
        const LocationIcon = this.services.theme.currentTheme.icons.locationIcon;
        return (
            <MobileMenuItemContainerBox className="cy-menu-item">
                <GenericSideMenuIconBox>
                    <LocationIcon size={2} />
                </GenericSideMenuIconBox>
                <MobileMenuItemLinkBox className="cy-help-mobile-link" onClick={this._openStateSelectorPopup}>
                    {this.services.translation.translate("STATE_SELECTOR_MENU_ITEM")}
                </MobileMenuItemLinkBox>
                <StateSelectorButtonComponent/>
            </MobileMenuItemContainerBox>
        );
    }
}